const info = {
  appName: 'CAT Capture Application',
  shortName: 'CAT',
  companyName: 'CAT',
  logo: {
    source: {
      uri: 'logo_cat.png',
    },
    width: 160,
    height: 71,
  },
  description: 'CAT Capture App enables high level car inspections with helpers and specific user interfaces.',
  vm: false,
  resolution: 'QHD'
};

export default info;
